function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class SimpleSearch {
    // Simple fuzzy search method
    search(query) {
        // function to remove all non-alphanumeric characters, including spaces and periods
        function removeNonAlphanumeric(str) {
            return str.replace(/[^a-zA-Z0-9]/g, "");
        }
        const queryNonAlphanumeric = removeNonAlphanumeric(query.toLowerCase());
        return this.data.filter((item)=>{
            const itemString = removeNonAlphanumeric(this.stringify(item).toLowerCase());
            const match = itemString.includes(queryNonAlphanumeric);
            return match ? 1 : 0;
        });
    }
    constructor(data, stringify){
        _define_property(this, "data", void 0);
        _define_property(this, "stringify", void 0);
        this.data = data;
        this.stringify = stringify // A function to convert each item to a string for comparison
        ;
    }
}
